var FIGURE = FIGURE || {};

// Raises a bootstrap modal opened from inside the consent layer above that layer (WEB-485).
//
// offset-consent's `copy.body` carries
// `<a href="/privacy/" data-toggle="modal" data-target="#figureModalMed">Privacy Policy</a>`,
// and renders that same copy into both the cookie banner and the Privacy Settings modal. Clicking
// it opens a bootstrap modal at the 10000 OffsetBaseResources gives `.modal`, which is below the
// consent layer at 10050/10051 — so the Privacy Policy loads behind the Privacy Settings modal
// that launched it.
//
// The layers are stacked that way on purpose: a shown `.modal` is a transparent, full-viewport
// fixed box, so when it sat above the banner it swallowed every click on Manage / Reject / Accept
// (WEB-465, fixed in _cantina-override.scss). Swapping the two globally just trades one ticket for
// the other. Keying off where the trigger lives raises only the modal the consent layer itself
// opened — from the banner or the modal, both of which render that link — and leaves every other
// modal on the site exactly where it was.
FIGURE.consentModalLayer = function () {
    // Bootstrap 4's modal events are jQuery events, and `relatedTarget` is the element that
    // triggered the show — the same hook OffsetBaseResources' FIGURE.modaler uses to find the href.
    if (!window.jQuery) return;

    window.jQuery(document)
        .on('show.bs.modal', '.modal', function (e) {
            var trigger = e.relatedTarget;
            if (trigger && trigger.closest && trigger.closest('#oc-root')) {
                this.classList.add('above-consent');
            }
        })
        // Cleared on hide so the next opener of this shared modal — #figureModalMed is site-wide —
        // gets the default stacking back.
        .on('hidden.bs.modal', '.modal', function () {
            this.classList.remove('above-consent');
        });
}();
